import React, { useRef } from 'react';

import cs from 'classnames';

import { otherProblemsList } from '../../../../../lib/constants/constants';
import Icon from '../../../Icon/Icon';
import Select from '../../../Select/Select';
import Textarea from '../../../Textarea/Textarea';

const OtherProblemsRow = ({ note, problems, id, onChange, newDesign }) => {
  const noteRef = useRef(null);

  return (
    <div className="flex items-center gap-4">
      <div className={cs(newDesign ? 'grid-cols-1' : 'grid-cols-2', 'grid w-full  gap-4')}>
        <Textarea
          label="Name"
          placeholder="Add note here"
          id="note"
          name="note"
          value={note}
          onChange={(event) => onChange('note', event.target.value, id)}
          disabled={false}
          transcribing
          forwardedRef={noteRef}
        />
        <Select
          label="Severity"
          isCreatable
          options={otherProblemsList}
          value={problems}
          disabled={false}
          onChange={(event) => onChange('problems', event, id)}
        />
      </div>
    </div>
  );
};

export default OtherProblemsRow;
